module.exports = __webpack_public_path__ + "static/img/14.84e43c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/zh/14.png
// module id = dpum
// module chunks = 0